var savedFormsData = {}

const saveFormsData = () => {
  var sessionData = JSON.parse(
    window.localStorage.getItem('tu.formularioCache')
  )
  sessionData = { ...sessionData, ...savedFormsData }
  window.localStorage.setItem('tu.formularioCache', JSON.stringify(sessionData))
}

export default {
  componentUpdated: (form) => {
    const formData = new FormData(form)

    savedFormsData[form.name] = [...formData].reduce(
      (result, [name, value]) => {
        result[name] = value
        return result
      },
      {}
    )

    saveFormsData()
  },
}
